import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { IMG_URL } from "../../config";

import Dashboard from "../Dashboard/Dashboard";
import "../../components/Profile/Profile.css";
import "./Achievements.css";


// import pink from "../../images/down-pink.svg";
// import gren from "../../images/down-gren.svg";
import "../../components/ResultTwo/ResultTwo.css";
import yellow from "../../images/yellowbadge.svg";
import star from "../../images/star.png";
import redb from "../../images/red-badge.svg";
import lock from "../../images/lock1.svg";
import grap from "../../images/greybadge.svg";
import pur from "../../images/purple-badge.svg";
import yel from "../../images/yellowbadge.svg";

import { END_URL } from "../../config";
import gren from "../../images/test2.jpg";
import pk from "../../images/pink.png";
import gn from "../../images/green.png";
import loadimg from "../../images/loader_wish.gif";

function Achievements({ token,onLoginChange, globaltest }) {

   const [loading, setLoading] = useState(false);

   const [BadgeData, setBadgeData] = useState([]);

   const [sortedBadges, setSortedBadges] = useState([]);

   function getBadgeimage(badgeimage) {

        const getBadgeimage = [yellow, redb, grap, pur, yel];

        return getBadgeimage[badgeimage] || yellow;
    }


     useEffect(() => {

        const GetUserResult = async () => {

            setLoading(true);

            try {

                const response = await axios.get(`${END_URL}/user_achievements`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                const reponsedata = response?.data;

                setBadgeData(reponsedata?.badges);

                setLoading(false);

            }
            catch {

                console.log('some error ');
            }

        };

        GetUserResult();

    }, [token]);


    console.log(BadgeData,'BadgeDataBadgeData');


  return (
    <div>
      <div className="result-cont profileCont achiev">
        <div className="container-fluid">
          <div className="row">

            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
              <Dashboard globaltest={globaltest}  />
            </div>

              <div className={`col-12 col-sm-12 col-md-7 col-lg-7 profile-mid achiev-mid acheivement-cont`}>

                {/* {loading ? (

                           <div className="profile-inner">
                                <div className='restwo-cont'>
                                    <div className="restwo-cont-sub">
                                    <div className="restwo-titl">
                                        <div className="skeleton3 skeleton3-achievements-title"></div>
                                    </div>

                                    <div className="restwo-badgeDiv">
                                        <div className="resttrwo-Box">
                                        {[...Array(8)].map((_, index) => (
                                            <div className="resttwo-bx1 skeleton3-achievement-card" key={index}>
                                            <div className="resttwo-icon-outer">
                                                <div className="resttwo-icon">
                                                <div className="skeleton3 skeleton3-badge-image"></div>
                                                </div>
                                            </div>

                                            <div className="resttwo-contn">
                                                <div className="rsttwo-im">
                                                <div className="skeleton3 skeleton3-badge-icon"></div>
                                                <div className="skeleton3 skeleton3-badge-title"></div>
                                                <div className="skeleton3 skeleton3-badge-date"></div>
                                                </div>

                                                <div className="skeleton3 skeleton3-badge-description"></div>
                                                <div className="skeleton3 skeleton3-badge-description short"></div>
                                            </div>
                                            </div>
                                        ))}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                    ) :  (  */}

                        <div className="profile-inner">
                        

                              <div className='restwo-cont'>
                            
                                <div className="restwo-cont-sub">
                                    <div className="restwo-titl">
                                        <h5>Achievements</h5>
                                    </div>
            
                                    <div className="restwo-badgeDiv">
            
                                        <div className="resttrwo-Box">
            
                                            {BadgeData && BadgeData.length > 0 ? (

                                                    BadgeData?.map((item, index) => (
                    
                                                        <div className="resttwo-bx1" key={index}>
                    
                                                            <div className="resttwo-icon-outer">
                                                                <div className="resttwo-icon">
                                                                    <img src={`${IMG_URL}/d0/${item.badge_image}`} alt="" />
                                                                </div>
                                                            </div>
                                                            <div className="resttwo-contn">
                    
                                                                <div className="rsttwo-im">
                                                                    <span><img src={getBadgeimage(index)} alt="" /></span>
                                                                    <span>{item.title}</span>
                                                                    
                                                                    { item?.created_at && (
                                                                        <span className="time-creater">{item?.created_at}</span>
                                                                    )}
                    
                                                                </div>
                                                        
                    
                                                                <p>{item.badge_description}</p>
                    
                    
                                                            </div>
                    
                                                        </div>

                                                    ))

                                                ) : (

                                                <div className="no-achievements">
                                                    
                                                    <p>No achievements achieved</p>
                                                </div>
                                            )}
            
            
                                        </div>
            
                                    </div>
            
            
                                </div>
            
                            </div>
                        

                        </div>

                        {/* // )} */}
              </div>
          
          
          </div>
        </div>
      </div>

    </div>
  );
}

export default Achievements;
